import type { PropsWithChildren } from 'react'

import { cn } from '@morpho-org/ui-v6/utils'

/**
 * Two-column grid for a page section next to this container, from `md` up. The panel column
 * is sized by the grid rather than by the panel (which fills its track), so a streamed page
 * whose panel HTML hasn't been parsed yet already paints its content at the final, narrower
 * width.
 */
export const SIMPLE_ACTION_PANEL_GRID =
  'md:grid md:grid-cols-[minmax(0,1fr)_360px] xl:grid-cols-[minmax(0,1fr)_430px]'

/**
 * Sticky container for the simple-action panel on vault / market pages.
 *
 * Note: the V5 source applied `hairlineMediaQuery('border-width')` here, which
 * only set `border-width` at high DPI with no `border-style`/`border-color`, so
 * it never rendered a visible border. It is intentionally omitted to keep 1:1
 * rendering (adding `border-[0.5px]` would surface a phantom currentColor
 * border under the Tailwind preflight `border-style: solid`).
 */
interface SimpleActionPanelStickyContainerProps extends PropsWithChildren {
  className?: string
  hideOnMobile?: boolean
}

const SimpleActionPanelStickyContainer = ({
  children,
  className,
  hideOnMobile = true
}: SimpleActionPanelStickyContainerProps) => {
  return (
    <div
      data-testid="simple-action-panel"
      className={cn(
        'pr-xl @max-[1420px]/content-root:pr-sm sticky top-0 z-1 mt-[calc(var(--navbar-height)-50px)] flex max-h-[calc(100vh-10px)] w-full shrink-0 overflow-y-auto pt-[86px] pl-px',
        hideOnMobile && 'max-md:hidden',
        className
      )}
    >
      {children}
    </div>
  )
}

export default SimpleActionPanelStickyContainer
